import React, { useEffect } from "react";

import useLayoutStore from "store/useLayoutStore";
import { Error404 } from "container/Error/Error404";
const Error404Page = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <Error404 />
    </>
  );
};

export default Error404Page;
